document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-carousel-direction]');
  if (!control) return;

  const section = control.closest('.product-section');
  const rail = section?.querySelector('.product-rail');
  if (!rail) return;

  const direction = control.dataset.carouselDirection === 'next' ? 1 : -1;
  const distance = Math.min(rail.clientWidth * 0.82, 620);
  rail.scrollBy({ left: distance * direction, behavior: 'smooth' });
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-auto-submit]');
  if (select?.form) select.form.submit();
});

const setCartButtonState = (form, state) => {
  const button = form.querySelector('[data-cart-state-button]');
  if (!button) return;

  const isQuickAdd = button.classList.contains('quick-add');
  const paymentButtonWrap = form.querySelector('[data-payment-button-wrap]');

  if (state === 'in-cart') {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-in-cart');
    button.textContent = button.dataset.inCartLabel || 'Already in cart';
    if (paymentButtonWrap) paymentButtonWrap.hidden = true;
    return;
  }

  if (state === 'sold-out') {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.remove('is-in-cart');
    button.textContent = 'Sold out';
    if (paymentButtonWrap) paymentButtonWrap.hidden = true;
    return;
  }

  if (state === 'adding') {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.remove('is-in-cart');
    button.textContent = isQuickAdd ? '…' : 'Adding...';
    if (paymentButtonWrap) paymentButtonWrap.hidden = true;
    return;
  }

  button.disabled = false;
  button.removeAttribute('aria-disabled');
  button.classList.remove('is-in-cart');
  button.innerHTML = isQuickAdd
    ? '+'
    : `${button.dataset.availableLabel || 'Add to cart'} <span>→</span>`;
  if (paymentButtonWrap) paymentButtonWrap.hidden = false;
};

document.addEventListener('change', (event) => {
  const select = event.target.closest('.product-form select[name="id"]');
  if (!select) return;

  const selectedOption = select.selectedOptions[0];
  if (selectedOption?.dataset.inCart === 'true') {
    setCartButtonState(select.form, 'in-cart');
  } else if (selectedOption?.dataset.available !== 'true') {
    setCartButtonState(select.form, 'sold-out');
  } else {
    setCartButtonState(select.form, 'available');
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form.cart-limit-form');
  if (!form) return;
  if (event.submitter && !event.submitter.matches('[data-cart-state-button]')) return;

  event.preventDefault();
  if (form.dataset.cartSubmitting === 'true') return;

  const variantField = form.elements.id;
  const variantId = Number(variantField?.value);
  const button = form.querySelector('[data-cart-state-button]');
  if (!variantId || !button || button.disabled) return;

  form.dataset.cartSubmitting = 'true';
  setCartButtonState(form, 'adding');

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to check cart');

    const currentCart = await response.json();
    const alreadyInCart = currentCart.items.some((item) => Number(item.variant_id) === variantId);
    if (alreadyInCart) {
      form.dataset.cartSubmitting = 'false';
      setCartButtonState(form, 'in-cart');
      return;
    }
  } catch (error) {
    // Shopify's server-side quantity limit remains the final safeguard.
  }

  HTMLFormElement.prototype.submit.call(form);
});

document.addEventListener('shopify:section:load', () => {
  document.documentElement.classList.remove('no-js');
});

const productImagePreloads = new Map();

const preloadImageUrl = (imageUrl, fetchPriority = 'high') => {
  if (!imageUrl || productImagePreloads.has(imageUrl)) return;

  const image = new Image();
  image.decoding = 'async';
  image.fetchPriority = fetchPriority;
  image.src = imageUrl;
  productImagePreloads.set(imageUrl, image);
};

const preloadProductImage = (target) => {
  const productCard = target.closest('[data-product-image-preload]');
  const imageUrl = productCard?.dataset.productImagePreload;
  preloadImageUrl(imageUrl);
};

document.addEventListener('pointerover', (event) => {
  preloadProductImage(event.target);
});

document.addEventListener('focusin', (event) => {
  preloadProductImage(event.target);
});

document.addEventListener('touchstart', (event) => {
  preloadProductImage(event.target);
}, { passive: true });

const preloadLightboxNeighbours = () => {
  const activeLightbox = document.querySelector('.product-lightbox-overlay:target');
  if (!activeLightbox) return;

  [activeLightbox.dataset.previousLightbox, activeLightbox.dataset.nextLightbox].forEach((targetId) => {
    const neighbour = targetId ? document.getElementById(targetId) : null;
    const neighbourImage = neighbour?.querySelector('.product-lightbox-figure img');
    preloadImageUrl(neighbourImage?.getAttribute('src'), 'low');
  });
};

window.addEventListener('hashchange', preloadLightboxNeighbours);
preloadLightboxNeighbours();

let productLightboxTouchStart = null;

document.addEventListener('touchstart', (event) => {
  const lightbox = event.target.closest('.product-lightbox-overlay');
  if (!lightbox?.matches(':target') || event.touches.length !== 1) {
    productLightboxTouchStart = null;
    return;
  }

  const touch = event.touches[0];
  productLightboxTouchStart = {
    lightbox,
    x: touch.clientX,
    y: touch.clientY
  };
}, { passive: true });

document.addEventListener('touchend', (event) => {
  if (!productLightboxTouchStart || event.changedTouches.length === 0) return;

  const touch = event.changedTouches[0];
  const horizontalDistance = touch.clientX - productLightboxTouchStart.x;
  const verticalDistance = touch.clientY - productLightboxTouchStart.y;
  const lightbox = productLightboxTouchStart.lightbox;
  productLightboxTouchStart = null;

  if (Math.abs(horizontalDistance) < 45) return;
  if (Math.abs(horizontalDistance) <= Math.abs(verticalDistance) * 1.15) return;

  const targetId = horizontalDistance < 0
    ? lightbox.dataset.nextLightbox
    : lightbox.dataset.previousLightbox;

  if (targetId) window.location.hash = targetId;
}, { passive: true });

document.addEventListener('touchcancel', () => {
  productLightboxTouchStart = null;
}, { passive: true });
